import { useState, useEffect } from 'react'
import { track } from '@amplitude/analytics-browser'
import { setPageView } from 'src/reducers/collection/action'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
export const useTabList = dispatch => {
  const history = useHistory()
  const pageViewPage = useSelector(state => state.collection.pageView)

  const [tabList, setTabList] = useState([
    { label: 'Mini courses', pageView: 'Mini Courses', path: 'mini-courses' },
    { label: 'Landing page', pageView: 'Landing Page', path: 'landing-page' },
    {
      label: 'Settings',
      pageView: 'Settings',
      path: 'settings/learner-authentication',
    },
    { label: 'Learners', pageView: 'Learners', path: 'learners' },
    { label: 'Analytics', pageView: 'Analytics', path: 'analytics' },
    { label: 'Share', pageView: 'Share', path: 'share' },
  ])
  const { id, page, subPage } = useParams()

  useEffect(() => {
    setTabList(prevTabs =>
      prevTabs.map(tab => ({
        ...tab,
        isActive: tab.pageView.toLowerCase().replace(' ', '-') === page,
      })),
    )
    dispatch(
      setPageView(
        tabList.find(x =>
          x.path.includes(pageViewPage.toLowerCase().replace(' ', '-')),
        ).pageView,
      ),
    )
  }, [page])

  const handleTabClick = pageView => {
    track('collection_page_selector', { pageView })
    const path = tabList.find(x => x.pageView === pageView).path
    history.push(`/collection/${id}/${path}`)
    dispatch(setPageView(pageView.toLowerCase().replace(' ', '-')))
  }

  const tabListWithHandlers = tabList.map(tab => ({
    ...tab,
    onClick: () => handleTabClick(tab.pageView),
  }))

  return { tabList: tabListWithHandlers, handleTabClick }
}
